module.exports = __webpack_public_path__ + "static/media/hotel_not_available_anymore.a7c7550e.png";